const isMedicoExterno = medico => medico?.tipo === 'Externo';

export default isMedicoExterno;
